export default __webpack_public_path__ + "img/hourback-906a36eb.png";